import React, { useEffect, useState } from "react";
import { FiPrinter } from "react-icons/fi";
import { MdOutlineFindInPage, MdOutlineAddCircleOutline } from "react-icons/md";
import dayjs from "dayjs";
import { useRef } from 'react';
import ToastNotification from '../../../components/ToastNotification';

const PayrollReport = () => {
    const modalContentRef = useRef();
  const [empData, setEmpData] = useState([]);
  const [selectedMonth, setSelectedMonth] = useState(dayjs().format("YYYY-MM"));
  const [selectedEmp, setSelectedEmp] = useState(null);
  const [existingPayroll, setExistingPayroll] = useState(null);
 
  const [toast, setToast] = useState({
         show: false,
         message: '',
         bg: 'success'
     });
 
       const showToast = (message, bg = 'success') => {
         setToast({ show: true, message, bg });
     };


useEffect(() => {
  const fetchPayrolls = async () => {
    try {
      const res = await fetch(
        `https://api.skyguard.group/api/get-employees-with-payroll?month=${selectedMonth}`
      );
      const data = await res.json();
 
      setEmpData(data); 
      showToast("Payroll fetch successfully!", 'success');
    } catch (err) {
      console.error(err);
        showToast("Failed to fetch payroll data", 'danger');
    }
  };

  fetchPayrolls();
}, [selectedMonth]);

  // Handle click on payroll icon
  const handlePayrollClick = async (emp) => {
    try {
      const res = await fetch(
        `https://api.skyguard.group/api/get-payroll?empId=${emp.emp_id}&month=${selectedMonth}`
      );
      const data = await res.json();

      if (data.exists) {
        // Parse JSON fields
        const payroll = data.payroll;
        payroll.payheads = JSON.parse(payroll.payheads || "[]");
        payroll.additional_earnings = JSON.parse(payroll.additional_earnings || "[]");
        payroll.deductions = JSON.parse(payroll.deductions || "[]");

        setExistingPayroll(payroll);
        setSelectedEmp(emp);
      } else {
        setSelectedEmp(null);
        setExistingPayroll(null);
      }
    } catch (err) {
      console.error(err);
      showToast('Failed to load payroll','danger')
    }
  };

 
  const handlePrint = () => {
    window.print();
  };

  
  return (
    <>
  
      <div className={`main-section ${selectedEmp || existingPayroll ? "blurred" : ""}`}>
        <div className="container-fluid dashboard-wrapper p-3 bg-body-secondary">
             <ToastNotification
                show={toast.show}
                message={toast.message}
                bg={toast.bg}
                onClose={() => setToast(prev => ({ ...prev, show: false }))}
            />
          <h3 className="my-3 fw-bold fs-5 golos">Payroll Report</h3>

     
          <div className="mb-3 row gx-3 gy-2 align-items-center">
            <div className="col-12 col-md-4">
              <label htmlFor="attendanceMonth" className="form-label fw-medium">
                Select Month:
              </label>
              <input
                type="month"
                className="form-control"
                id="attendanceMonth"
                value={selectedMonth}
                onChange={(e) => setSelectedMonth(e.target.value)}
              />
            </div>
          </div>

 
          <div className="table-responsive shadow p-3 mb-5 bg-body-tertiary rounded my-4">
            <table className="table table-bordered table-striped table-hover table-sm text-center align-middle">
              <thead className="table-info">
                <tr>
                        <th>Action</th>
                  <th>Emp ID</th>
                  <th>Emp Name</th>
                  <th>Department</th>
                  <th>Designation</th>
            
                </tr>
              </thead>
              <tbody>
                {empData.map((emp, idx) => (
                  <tr key={idx}>
                          <td> <MdOutlineFindInPage
                          title="View Payroll"
                          size={20}
                          style={{ cursor: "pointer", color: "green" }}
                          onClick={() => handlePayrollClick(emp)}
                        /> </td>
                    <td>{emp.emp_id}</td>
                    <td>{emp.emp_name}</td>
                    <td>{emp.department || "-"}</td>
                    <td>{emp.designation || "-"}</td>
              
                  
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>

 
      {/* {(selectedEmp || existingPayroll) && (
       <div ref={modalContentRef} className="modal-overlay">
          <div className="modal-content shadow p-1 rounded">
       
            <div className="text-center mb-3">
              <h5 className="mb-0">Star Signature Services</h5>
              <small>Vasai</small>
              <h6 className="mt-2">PAYSLIP</h6>
              <small>{selectedMonth}</small>
            </div>

            <div className="row mb-2">
              <div className="col-6">
                <p className="mb-1">
                  <strong>Emp. ID</strong><span className="ms-2">{(selectedEmp || existingPayroll)?.emp_id}</span>
                </p>
                <p className="mb-1">
                  <strong>Emp Name</strong> <span className="ms-2">{(selectedEmp || existingPayroll)?.emp_name}</span>
                </p>
                <p className="mb-1">
                  <strong>Department</strong> <span className="ms-2">{(selectedEmp || existingPayroll)?.department || "-"}</span>
                </p>
                <p className="mb-1">
                  <strong>Designation</strong> <span className="ms-2">{(selectedEmp || existingPayroll)?.designation || "-"}</span>
                </p>
              </div>
              <div className="col-6">
                <p className="mb-1">
                  <strong>Basic</strong>{" "}
                  <span className="ms-2">{(existingPayroll?.basic_salary || selectedEmp?.basic || 0).toLocaleString()}</span>
                </p>
                <p className="mb-1"><strong>Paid Days  </strong><span>{existingPayroll.paid_days} </span></p>
                <p className="mb-1">
                  <strong>NetPay</strong>{" "}
                  <span className="ms-2">
                    {existingPayroll
                      ? existingPayroll.net_salary.toLocaleString()
                      : selectedEmp?.basic?.toLocaleString() || "0"}
                  </span>
                </p>
              </div>
            </div>

      
            <div className="bg-white p-3 rounded shadow mb-3">
              <h6 className="text-center mb-2">Payheads</h6>
              <table className="table table-bordered mb-0">
                <thead className="table-light">
                  <tr>
                    <th>Description</th>
                    <th className="text-end">Amount</th>
                  </tr>
                </thead>
                <tbody>
                  {(existingPayroll?.payheads || selectedEmp?.payhead_data || []).map((ph, i) => (
                    <tr key={i}>
                      <td>{ph.name}</td>
                      <td className="text-end">{ph.amount}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

  
            <div className="d-flex gap-4 mb-3">
     
              <div className="bg-white p-3 rounded shadow flex-fill">
                <h6 className="text-center">Additional Earnings</h6>
                <table className="table table-bordered mb-0">
                  <thead className="table-light">
                    <tr>
                      <th>Description</th>
                      <th className="text-end">Amount</th>
                    </tr>
                  </thead>
                  <tbody>
                    {(existingPayroll?.additional_earnings || selectedEmp?.additionalEarnings || []).map((ae, i) => (
                      <tr key={i}>
                        <td>{ae.name}</td>
                        <td className="text-end">{ae.amount}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

  
              <div className="bg-white p-3 rounded shadow flex-fill">
                <h6 className="text-center">Deductions</h6>
                <table className="table table-bordered mb-0">
                  <thead className="table-light">
                    <tr>
                      <th>Description</th>
                      <th className="text-end">Amount</th>
                    </tr>
                  </thead>
                  <tbody>
                    {(existingPayroll?.deductions || selectedEmp?.deductions || []).map((ded, i) => (
                      <tr key={i}>
                        <td>{ded.name}</td>
                        <td className="text-end">{ded.amount}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>

  
            <div className="bg-white p-3 rounded shadow mb-3" style={{ width: "250px" }}>
              <h6>Net Salary</h6>
              <p style={{ fontWeight: "bold", fontSize: "1.2rem" }}>
                {existingPayroll
                  ? existingPayroll.net_salary.toLocaleString()
                  : selectedEmp?.basic?.toLocaleString() || 0}
              </p>
            </div>

      
            <div className="d-flex justify-content-end gap-2">
              <button className="btn btn-primary d-flex align-items-center" onClick={handlePrint}>
                <FiPrinter className="me-1" /> Print
              </button>
              <button className="btn btn-danger" onClick={() => { setSelectedEmp(null); setExistingPayroll(null); }}>
                Close
              </button>
            </div>
          </div>
        </div>
      )} */}

      {(selectedEmp || existingPayroll) && (
  <div className="modal-overlay d-flex justify-content-center align-items-center">
    
    <div className="modal-content bg-white shadow rounded p-3 w-100">

      {/* Scrollable body */}
      <div className="overflow-auto" style={{ maxHeight: "85vh" }}>

        {/* Header */}
        <div className="text-center mb-2">
          <h6 className="mb-0">Star Signature Services</h6>
          <small>Vasai</small>
          <div className="fw-bold mt-1">PAYSLIP</div>
          <small>{selectedMonth}</small>
        </div>

        {/* Employee Info */}
        <div className="row mb-2">
          <div className="col-6 small">
            <div><strong>Emp ID:</strong> {(selectedEmp || existingPayroll)?.emp_id}</div>
            <div><strong>Name:</strong> {(selectedEmp || existingPayroll)?.emp_name}</div>
            <div><strong>Dept:</strong> {(selectedEmp || existingPayroll)?.department || "-"}</div>
            <div><strong>Desig:</strong> {(selectedEmp || existingPayroll)?.designation || "-"}</div>
          </div>

          <div className="col-6 small">
            <div>
              <strong>Basic:</strong>{" "}
              {(existingPayroll?.basic_salary || selectedEmp?.basic || 0).toLocaleString()}
            </div>
            <div>
              <strong>Paid Days:</strong> {existingPayroll?.paid_days || 0}
            </div>
            <div>
              <strong>Net Pay:</strong>{" "}
              {(existingPayroll?.net_salary || selectedEmp?.basic || 0).toLocaleString()}
            </div>
          </div>
        </div>

        {/* Payheads */}
        <div className="card mb-2">
          <div className="card-header text-center py-1 fw-bold">
            Payheads
          </div>
          <div className="card-body p-2">
            <table className="table table-sm table-bordered mb-0">
              <thead>
                <tr>
                  <th>Description</th>
                  <th className="text-end">Amount</th>
                </tr>
              </thead>
              <tbody>
                {(existingPayroll?.payheads || selectedEmp?.payhead_data || []).map((ph, i) => (
                  <tr key={i}>
                    <td>{ph.name}</td>
                    <td className="text-end">{ph.amount}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        {/* Earnings & Deductions */}
        <div className="row g-2 mb-2">

          <div className="col-6">
            <div className="card">
              <div className="card-header text-center py-1 fw-bold">
                Earnings
              </div>
              <div className="card-body p-2">
                <table className="table table-sm table-bordered mb-0">
                  <tbody>
                    {(existingPayroll?.additional_earnings || []).map((ae, i) => (
                      <tr key={i}>
                        <td>{ae.name}</td>
                        <td className="text-end">{ae.amount}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <div className="col-6">
            <div className="card">
              <div className="card-header text-center py-1 fw-bold">
                Deductions
              </div>
              <div className="card-body p-2">
                <table className="table table-sm table-bordered mb-0">
                  <tbody>
                    {(existingPayroll?.deductions || []).map((d, i) => (
                      <tr key={i}>
                        <td>{d.name}</td>
                        <td className="text-end">{d.amount}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>

        </div>

        {/* Net Salary */}
        <div className="text-center mb-2">
          <div className="fw-bold">Net Salary</div>
          <div className="fs-5 fw-bold text-success">
            {(existingPayroll?.net_salary || selectedEmp?.basic || 0).toLocaleString()}
          </div>
        </div>

      </div>

      {/* Buttons */}
      <div className="d-flex justify-content-end gap-2 mt-2">
        <button className="btn btn-primary btn-sm" onClick={handlePrint}>
          Print
        </button>

        <button
          className="btn btn-danger btn-sm"
          onClick={() => {
            setSelectedEmp(null);
            setExistingPayroll(null);
          }}
        >
          Close
        </button>
      </div>

    </div>
  </div>
)}

<style jsx>{`
  .blurred { filter: blur(4px); pointer-events: none; }

  .modal-overlay {
    position: fixed;
    top: 0; left: 0;
    width: 100vw; height: 100vh;
    background: rgba(0,0,0,0.4);
    display: flex; justify-content: center; align-items: center;
    z-index: 2000;
  }

  .modal-content {
    background: #fff;
    max-width: 800px;
    width: 95%;
    border-radius: 8px;
    padding: 20px;
    z-index: 2001;
  }

  /* PRINT STYLES */
  @media print {
    body * {
      visibility: hidden !important;
    }
    .modal-content, .modal-content * {
      visibility: visible !important;
    }
    .modal-content {
      position: absolute;
      top: 0;
      left: 0;
      width: 100% !important;
      max-width: 100% !important;
      margin: 0 !important;
      padding: 20px !important;
      background: white !important;
    }
    /* Hide buttons */
    .modal-content .btn {
      display: none !important;
    }
  }
`}</style>
    </>
  );
};

export default PayrollReport;





